export const USERPILOT_TOKEN = '21ib23t9';

export const USERPILOT_CHECKLIST_PARAMETER_NAME = 'cl';
export const USERPILOT_CHECKLIST_PARAMETER_VALUE_BLOCKPAGE = 1;
